import { createReducer } from 'redux-act';

import {
  ACTIONS_NAMES_DICT,
  ENTITY_ACTIONS as ACTIONS,
} from 'state/actions/users';

import defaultReducer from '../default';

const usersReducerOptions = defaultReducer({ ACTIONS_NAMES_DICT, ACTIONS });
const { reducerShape, initialState } = usersReducerOptions;
export const usersReducer = createReducer(reducerShape, initialState);
